import ruMessage from "@/messages/ru.json";
import enMessage from "@/messages/en.json";
import kzMessage from "@/messages/kz.json";
import cnMessage from "@/messages/cn.json";

export const messages: { [key in any]: any } = {
  ru: ruMessage,
  en: enMessage,
  kz: kzMessage,
  cn: cnMessage,
};
